import React, { Component } from "react";
import SavedEntriesItem from "./SavedEntriesItem";


class SavedEntriesList extends Component {
    render() {
        const { entries } = this.props
        return (
            <div>
                {entries && entries.map(entry => {
                    return (
                        <div key={entry.id} >
                            <SavedEntriesItem key={entry.id} entry={entry} />
                        </div>
                    )
                })}
            </div>
        );
    }
}

export default SavedEntriesList;



// WEBPACK FOOTER //
// ./src/Components/SavedPage/SavedEntriesList.jsx